import { Box, useTheme } from "@material-ui/core";
import { motion, Variants } from "framer-motion";
import React from "react";

export default function SwipeableViewsControls({ amount, index, onItemClick }) {
  const theme = useTheme();

  const animations: Variants = {
    initial: {
      width: "10px",
      backgroundColor: theme.palette.grey[400]
    },
    active: {
      width: "24px",
      backgroundColor: theme.palette.orange
    }
  };

  return (
    <Box mt={2} display="flex" justifyContent="center">
      {Array.from({ length: amount }).map((_, i) => (
        <motion.div
          key={i}
          onClick={() => onItemClick(i)}
          variants={animations}
          initial="initial"
          animate={i === index ? "active" : "initial"}
          style={{
            height: `3px`,
            borderRadius: `6px`,
            marginRight: `2px`,
            cursor: `pointer`
          }}
        />
      ))}
    </Box>
  );
}
